import { useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { calculateFinancialSummary, 
  formatCurrency, 
  getVal, 
  setBool,
  isNegative,
  formatDate 
} from '../../helpers/process_morningstar.js';

import {
  Box,
  Container,
  CircularProgress,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableContainer,
  TableRow,
  Paper
} from "@mui/material";


export default function Dividends() {
  const tableRef = useRef(null);
  const [tables, setTables] = useState([]);
  const [error, setError] = useState(null);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [Tax, setTax] = useState(false);
  const [capRD, setCapRD] = useState(getVal("capRD"));
  const [includeOtherIncome, setIncludeOtherIncome] = useState(getVal("includeOtherIncome"));

  useEffect(() => {
    if (tableRef.current) {
      const el = tableRef.current;
      el.scrollTo({
        left: el.scrollWidth,
      });
    }
  }, [currentTableData]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "capRD") setCapRD(JSON.parse(event.newValue));
      if (event.key === "includeOtherIncome") setIncludeOtherIncome(JSON.parse(event.newValue));
    };
  
    const handleCustomUpdate = () => {
      setCapRD(getVal("capRD"));
      setIncludeOtherIncome(getVal("includeOtherIncome"));
    };
  
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("localStorageUpdated", handleCustomUpdate);
  
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("localStorageUpdated", handleCustomUpdate);
    };
  }, []);

  useEffect(() => {
  const fetchData = async () => {
    const financialSummaryData = await calculateFinancialSummary(capRD, includeOtherIncome, Tax);
    setCurrentTableData(financialSummaryData);
  };

  fetchData();
}, [capRD, includeOtherIncome, Tax]);


  if (error) return <div>Error: {error}</div>;

      return (
        <>
            <>

              {currentTableData.length > 0 ? (
              <Box sx={{ mx: "25px" }}>
               <TableContainer component={Paper} sx={{ boxShadow: "none", pb: 10 }} ref={tableRef}>
                 <Table stickyHeader size="small">
                  <TableHead>
                      {[{ value : "Date", time: "Time" }].map((item, idx) => (
                      <TableRow>
                        <TableCell 
                          sx={{ 
                            backgroundColor: "#F9FAFB", 
                            borderRight: "1px solid #969696ff",
                            fontWeight: "bold", 
                            color: "black",
                            position: "sticky", 
                            left: 0, 
                            zIndex: 3, 
                            minWidth: 180,
                          }}
                        >
                          Date
                        </TableCell>
                        {currentTableData.map((row, colIdx) => (
                          <TableCell sx={{backgroundColor: row[item.time] === "Annual" ? "#324052" : "#FFF176", 
                              borderRight: "1px solid #969696ff",
                              color: row[item.time] === "Annual" ? "white" : "black", 
                              whiteSpace: 'nowrap',
                              padding: 0,
                              minWidth: 60,
                             }} 
                              key={colIdx}
                          >
                            <div style={{ 
                              textAlign: "center",
                               fontSize: "0.67rem",
                               padding: 0
                               }}
                            >
                              {row[item.time]}
                            </div>
                            <div style={{ 
                              fontSize: "0.67rem",
                              textAlign: "center",
                              fontWeight: "bold",
                              textDecoration: "underline",
                              }}
                            >
                              {formatDate(row[item.value])}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableHead>
                   <TableBody>
                     {[
                      { label: "Dividends", field: "dividendPerShare" },
                      { label: "Price", field: "price" },
                      { label: " ", field: " " },
                      { label: "Dividend Yield:", field: "dividendYield" },
                      { label: "Dividend Growth", field: "dividendGrowth" },
                      { label: "", field: "" },
                      { label: "Payout Ratio", field: "" },
                      { label: "Cash Flow From Ops - Interest", field: "cfInterest" },
                      { label: "Shares (M)", field: "basicAverageShares" },
                      { label: "Cash Flow From Ops Per Share", field: "cashFlowPerShare" },
                      { label: "", field: "" },
                      { label: "", field: "" },     
                    ].map((rowItem, rowIdx) => (
                      <TableRow
                        key={rowIdx}
                        sx={{
                          backgroundColor: rowIdx % 2 === 0 ? "#ffffff" : "#F9FAFB",
                          "& td": { fontSize: "0.67rem", borderBottom: "1px solid #E5E7EB", padding: "1px 8px" },
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {/* Render the row label as first cell */}
                        <TableCell sx={{ 
                          borderRight: "1px solid #969696ff",
                          fontWeight: 'bold',
                          whiteSpace: 'nowrap',
                          position: "sticky", 
                          left: 0, 
                          zIndex: 2,
                          height: 15,
                          backgroundColor: rowIdx % 2 === 0 ? "#ffffff" : "#F9FAFB" 
                          }}
                        >
                          {rowItem.label}
                        </TableCell>

                        {/* Render the financial data cells */}
                        {currentTableData.map((row, colIdx) => (
                          <TableCell key={colIdx} sx={{ 
                            borderRight: "1px solid #969696ff",
                            color: isNegative(row[rowItem.field]) ? "red" : "inherit",
                            textAlign: "right",
                          }}>
                            {formatCurrency(row[rowItem.field])}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                <Table stickyHeader size="small">
                  <TableHead>
                      {[{ value : "Date", time: "Time" }].map((item, idx) => (
                      <TableRow>
                        <TableCell 
                          sx={{ 
                            backgroundColor: "#F9FAFB", 
                            borderRight: "1px solid #969696ff",
                            fontWeight: "bold", 
                            color: "black",
                            position: "sticky", 
                            left: 0, 
                            zIndex: 3, 
                            minWidth: 180,
                          }}
                        >
                          Dividends and Yield Chart
                        </TableCell>
                        {currentTableData.map((row, colIdx) => (
                          <TableCell sx={{backgroundColor: row[item.time] === "Annual" ? "#324052" : "#FFF176", 
                              borderRight: "1px solid #969696ff",
                              color: row[item.time] === "Annual" ? "white" : "black", 
                              whiteSpace: 'nowrap',
                              padding: 0,
                              minWidth: 60
                            }} 
                              key={colIdx}
                          >
                            <div style={{ textAlign: "center", fontSize: "0.67rem" }}>{row[item.time]}</div>
                            <div style={{ 
                              fontSize: "0.67rem",
                              textAlign: "center",
                              fontWeight: "bold",
                              textDecoration: "underline",
                              }}
                            >
                              {formatDate(row[item.value])}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableHead>
                                  <TableBody>
                                    {[
                                      { label: "Quarterly Dividends", value: "dividendPerShare" },
                                      { label: "Yield", value: "dividendYield" },
                                      { label: "", value: "" },
                                      { label: "CF, Div and Payout Ratio", value: "Date" },
                                      { label: "TFQ Cash Available PS", value: "cashAvailable" },
                                      { label: "TFQ Dividends PS", value: "tfqDividends" },
                                      { label: "Payout Ratio", value: "payoutRatio" },

                                    ].map((item, idx) => (
                                    <TableRow key={idx}
                                        sx={{
                                          borderRight: "1px solid #969696ff",
                                          backgroundColor: idx % 2 === 0 ? "#ffffff" : "#F9FAFB",
                                          "& td": { fontSize: "0.67rem", borderBottom: "1px solid #E5E7EB", padding: "1px 8px" },
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                      <TableCell sx={{ 
                                        borderRight: "1px solid #969696ff",
                                        fontWeight: "bold", 
                                        whiteSpace: 'nowrap',
                                        position: "sticky", 
                                        left: 0, 
                                        zIndex: 2,  
                                        height: 15,
                                        backgroundColor: idx % 2 === 0 ? "#ffffff" : "#F9FAFB",
                                        }}
                                      >
                                        {item.label}
                                      </TableCell>
                                      {currentTableData.map((row, colIdx) => (
                                        <TableCell key={colIdx} sx={{ 
                                          borderRight: "1px solid #969696ff",
                                          color: isNegative(row[item.value]) ? "red" : "inherit",
                                          textAlign: "right"
                                        }}>
                                         {item.value === "Date" ? (
                                            <div>
                                              {formatDate(row[item.value])}
                                            </div>
                                          ) : (
                                            formatCurrency(row[item.value])
                                          )}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>

              </TableContainer>
              </Box>
            ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "50vh", // full screen height
                    }}
                  >
                    <h3>Loading...</h3>
                    <CircularProgress />
                  </div>
            )}
        </>
    </>
  )}